"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LateChangeReason = void 0;
require("antd/lib/input/style");
var _input = _interopRequireDefault(require("antd/lib/input"));
require("antd/lib/radio/style");
var _radio = _interopRequireDefault(require("antd/lib/radio"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../utils");
require("./LateChangeReason.less");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var AppointmentChangeReasonMessage = {
  CTAMessage: 'Please select a reason',
  OptionalMessage: '(optional)',
  LateChangeMessage: '(required for changes within 24 hours of an appointment)'
};
var AppointmentChangeReason = {
  emergency: 'Emergency (e.g. medical)',
  logistical: 'Technical issues',
  memberRequested: 'Logistical (e.g. stuck at work, childcare)',
  overScheduled: 'Over-scheduled',
  technicalIssues: 'Member requested cancellation / change',
  other: 'Other'
};
var getAppointmentChangeMessage = function getAppointmentChangeMessage(startsAt) {
  return "".concat(AppointmentChangeReasonMessage.CTAMessage).concat((0, _utils.isBookingLateChange)(startsAt) ? " ".concat(AppointmentChangeReasonMessage.LateChangeMessage) : " ".concat(AppointmentChangeReasonMessage.OptionalMessage), ":");
};
var LateChangeReason = function LateChangeReason(_ref) {
  var startsAt = _ref.startsAt,
    horizontal = _ref.horizontal,
    onSelect = _ref.onSelect;
  var otherReasonRef = (0, _react.useRef)(null);
  // internally manage reason state so that radio UI properly reflects selecting Other
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    reason = _useState2[0],
    setReason = _useState2[1];
  var handleSelectReason = function handleSelectReason(e) {
    var _otherReasonRef$curre, _otherReasonRef$curre2;
    var reason = e.target.value;
    setReason(reason);
    onSelect(reason === AppointmentChangeReason.other ? ((_otherReasonRef$curre = otherReasonRef.current) === null || _otherReasonRef$curre === void 0 ? void 0 : (_otherReasonRef$curre2 = _otherReasonRef$curre.input) === null || _otherReasonRef$curre2 === void 0 ? void 0 : _otherReasonRef$curre2.value) || '' : reason);
  };
  var handleInputChange = function handleInputChange() {
    var _otherReasonRef$curre3, _otherReasonRef$curre4;
    setReason(AppointmentChangeReason.other);
    onSelect(((_otherReasonRef$curre3 = otherReasonRef.current) === null || _otherReasonRef$curre3 === void 0 ? void 0 : (_otherReasonRef$curre4 = _otherReasonRef$curre3.input) === null || _otherReasonRef$curre4 === void 0 ? void 0 : _otherReasonRef$curre4.value) || '');
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "late-change-reason"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-regular pb-[12px]"
  }, getAppointmentChangeMessage(startsAt)), /*#__PURE__*/_react.default.createElement(_radio.default.Group, {
    className: (0, _classnames.default)({
      'ant-radio-group-horizontal': horizontal
    }),
    size: "large",
    onChange: handleSelectReason,
    value: reason
  }, Object.values(AppointmentChangeReason).map(function (reason) {
    return reason !== AppointmentChangeReason.other && /*#__PURE__*/_react.default.createElement(_radio.default, {
      key: reason,
      value: reason
    }, reason);
  }), /*#__PURE__*/_react.default.createElement(_radio.default, {
    key: AppointmentChangeReason.other,
    value: AppointmentChangeReason.other
  }, "Other: ", /*#__PURE__*/_react.default.createElement(_input.default, {
    onChange: handleInputChange,
    ref: otherReasonRef
  }))));
};
exports.LateChangeReason = LateChangeReason;